import { Car } from "lucide-react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";

import { SquareRightArrowIcon, StopwatchIcon } from "../../assets/icons";

import { MODES } from "../../constants/booking-modes";

import { Button } from "../ui/button";

import { cn } from "../../utils/lib";

import { setPricingViewMode } from "../../redux/pricing/slice";

const MODES_TEXT = ["Oneway", "Hourly", "Long Distance"];

export function PricingModeViewTabs() {
  const dispatch = useDispatch();

  const pricingViewMode = useSelector(
    ({ pricing }) => pricing.currentPricingView
  );

  const { isZoneFetching } = useSelector(
    ({ pricing }) => pricing.cities[pricing.currentSelectedCityId]
  );

  return (
    <div className="h-11 bg-[#181E29] text-white border-none rounded-md mt-1 items-center flex px-0.5">
      {MODES.map((MODE, index) => (
        <div className="relative" key={MODE}>
          <Button asChild>
            <button
              disabled={isZoneFetching}
              onClick={() => {
                dispatch(setPricingViewMode({ view: MODE }));
              }}
              className={cn(
                "relative z-10 flex h-9 items-center gap-x-1 bg-transparent font-normal capitalize mix-blend-difference hover:bg-transparent [&_svg]:size-5 text-white",
                MODE === pricingViewMode && "disabled:bg-gray-500"
              )}
            >
              {MODE === MODES[0] && <SquareRightArrowIcon />}
              {MODE === MODES[1] && <StopwatchIcon />}
              {MODE === MODES[2] && <Car />}
              <span className="hidden lg:inline-block">
                {MODES_TEXT[index]}
              </span>
            </button>
          </Button>
          {MODE === pricingViewMode && (
            <motion.div
              initial={false}
              layoutId="price-mode"
              className="absolute inset-0 rounded-md bg-black"
              style={{ originY: "none" }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
